import { Component, Input } from '@angular/core';

/**
 * Generated class for the DrawerItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'drawer-item',
  templateUrl: 'drawer-item.html'
})
export class DrawerItemComponent {

  @Input() page: any;
  @Input() isSelected: boolean;

  constructor() {
    console.log('Hello DrawerItemComponent Component');
    this.isSelected = true
  }

}



// WEBPACK FOOTER //
// ./src/components/drawer-item/drawer-item.ts